import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil';
import outputs from 'root/cfOutput';
const { domainName } = outputs;
const SIZE_PRESETS = {
    thumbnail: 160,
    mobile: 720,
    desktop: 1920,
    hero: 1920,
};
const FILES_SEGMENT = '/files/';
const IMG_SEGMENT = '/img/';
const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif']);
function isImagePath(path) {
    const dot = path.lastIndexOf('.');
    if (dot < 0)
        return false;
    const [ext] = path.slice(dot + 1).toLowerCase().split(/[?#]/);
    return Boolean(ext) && IMAGE_EXTENSIONS.has(ext);
}
function isAppHost(url) {
    if (!domainName)
        return false;
    try {
        const { host } = new URL(url);
        return host === domainName || host.endsWith(`.${domainName}`);
    }
    catch (_) {
        return false;
    }
}
/**
 * Rewrite a stored asset URL (under /files/<key>) to the on-demand transform path
 * (/img/<key>?w=…&h=…&q=…&fmt=…). Passes through URLs that are not routed through the
 * app's file origin (legacy `desktop`/`mobile` variants, external URLs).
 */
export function buildAssetUrl(storedUrl, options = {}) {
    if (!storedUrl)
        return undefined;
    const withProtocol = addHttpsProtocol(storedUrl);
    if (!withProtocol)
        return undefined;
    const filesIndex = withProtocol.indexOf(FILES_SEGMENT);
    if (filesIndex < 0)
        return withProtocol;
    if (!isImagePath(withProtocol))
        return withProtocol;
    if (!isAppHost(withProtocol))
        return withProtocol;
    const base = `${withProtocol.slice(0, filesIndex)}${IMG_SEGMENT}${withProtocol.slice(filesIndex + FILES_SEGMENT.length)}`;
    return appendQuery(base, options);
}
export function assetSize(preset) {
    return SIZE_PRESETS[preset];
}
/**
 * Twitch stream thumbnails embed literal `{width}` / `{height}` placeholders that the client
 * must substitute before the image will load. No-op for URLs without them (YouTube, stored clips).
 */
export function resolveThumbnailPlaceholders(url, width = 640, height = 360) {
    if (!url)
        return undefined;
    return url.replace('{width}', String(width)).replace('{height}', String(height));
}
function appendQuery(url, { w, h, q, fmt }) {
    const params = [];
    if (typeof w === 'number' && w > 0)
        params.push(`w=${w}`);
    if (typeof h === 'number' && h > 0)
        params.push(`h=${h}`);
    if (typeof q === 'number' && q > 0)
        params.push(`q=${q}`);
    if (fmt)
        params.push(`fmt=${fmt}`);
    if (!params.length)
        return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${params.join('&')}`;
}
